import React, { useState } from "react";
import * as Yup from "yup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import { useAuth } from "../core/Auth";
import request, { gql } from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import MaterialInput from "../../../components/MaterialInput";
import {
  TextField,
  Card,
  CardContent,
  Typography,
  Button,
  FormControl,
  Icon,
  FormHelperText,
} from "@mui/material";
import axios from "axios";
import Swal from "sweetalert2";

export default function NewPassword() {
  // const { token } = useParams();
  const [password, setpassword] = useState({
    oldpassword: "",
    newpassword: "",
    oldPasswordSts: "unchecked",
    newPasswordSts: "unchecked",
  });
  const location = useLocation();
  const path = location?.pathname;

  const qa = path.split("/");
  const qavalue = qa[2];
  const token = qa[3];
  const [viewPassword, setViewPassword] = useState(false);
  const [viewPasswordnew, setViewPasswordnew] = useState(false);
  const [loading, setLoading] = useState(false);
  const handlePasswordVisibility = () => {
    setViewPassword(!viewPassword);
  };
  const handlePasswordVisibilitynew = () => {
    setViewPasswordnew(!viewPasswordnew);
  };
  const { saveAuth, setCurrentUser } = useAuth();
  const [error, setError] = useState("");
  const nav = useNavigate();

  const handleChange = (event) => {
    const lengthRegex = /([a-zA-Z0-9@$!%*?&]{3,8})$/;

    let signInState = { ...password };
    if (event.target.name === "oldpassword") {
      signInState.oldPasswordSts = lengthRegex.test(event.target.value)
        ? "success"
        : "error";
    } else if (event.target.name === "newpassword") {
      signInState.newPasswordSts =
        signInState?.newpassword == signInState?.oldpassword
          ? "success"
          : "error";
    }
    signInState[event.target.name] = event.target.value;
    setpassword(signInState);
  };
  //   const forgotpassword = async () => {
  //     const forgot = `mutation user_password($input: PasswordInput!){
  //   userNewPassword(input: $input){
  //     message
  //     success
  //     error
  //   }
  // }`;
  //     try {
  //       const response = await axios({
  //         url: BASEURL,
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         data: JSON.stringify({
  //           forgot,
  //           input: {
  //             newPassword1: password?.oldpassword,
  //             newPassword2: password?.newpassword,
  //             uidb64: qavalue,
  //             token: token,
  //           },
  //         }),
  //       });

  //     } catch (error) {
  //     }
  //   };
  const forgotpassword = async () => {
    const forgot = `
    mutation user_password($input: PasswordInput!) {
      userNewPassword(input: $input) {
        message
        success
        error
      }
    }
  `;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: forgot,
          variables: {
            input: {
              newPassword1: password?.oldpassword, // Assuming password.oldpassword is the correct field
              newPassword2: password?.newpassword, // Assuming password.newpassword is the correct field
              uidb64: qavalue,
              token: token,
            },
          },
        }),
      });
      if (response.data.data.userNewPassword.success) {
        Swal.fire({
          position: "center",
          icon: "success",
          title:response.data.data.userNewPassword.message,
          showConfirmButton: false,
          timer: 2500,
        });
        setTimeout(() => {
          nav("/");
        }, 2000);
      } else {
        Swal.fire({
          position: "center",
          icon: "error",
          title: response.data.data.userNewPassword.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }

    } catch (error) {
      console.error("Errorresponse:", error.response?.data || error.message);
    }
  };

  return (
    <section
      className="auth-section"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card sx={{ width: "100%", maxWidth: 400, padding: 2 }} elevation={3}>
        <CardContent>
          <Typography
            variant="h5"
            component="h3"
            align="center"
            gutterBottom
            sx={{ fontWeight: "bold", color: "#3F51B5", marginBottom: 3 }}
          >
            New Password
          </Typography>

          <div className="flex flex-col gap-4">
            <div className="relative">
              <MaterialInput
                placeholder="Enter password"
                type={viewPasswordnew ? "text" : "password"}
                fullWidth
                variant="outlined"
                size="medium"
                name="oldpassword"
                value={password?.oldpassword}
                onChange={handleChange}
                // onBlur={formik.handleBlur}
                error={password.oldPasswordSts === "error" ? true : false}
                success={password.oldPasswordSts === "success" ? true : false}
                icon={
                  viewPasswordnew
                    ? {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <VisibilityIcon
                              onClick={handlePasswordVisibilitynew}
                              style={{ cursor: "pointer" }}
                            />
                          </Icon>
                        ),
                      }
                    : {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <VisibilityOffIcon
                              onClick={handlePasswordVisibilitynew}
                              style={{ cursor: "pointer" }}
                            />
                          </Icon>
                        ),
                      }
                }
              />
              {password.oldPasswordSts === "error" ? (
                <FormControl error>
                  <FormHelperText>
                    Your password must be minimum 3 characters
                  </FormHelperText>
                </FormControl>
              ) : null}
            </div>
            <br></br>
            <div className="relative">
              <MaterialInput
                placeholder="Confirm password"
                type={viewPassword ? "text" : "password"}
                fullWidth
                variant="outlined"
                size="medium"
                name="newpassword"
                value={password?.newpassword}
                onChange={handleChange}
                error={
                  password.oldpassword?.length > 0 &&
                  password.oldpassword !== password.newpassword
                    ? true
                    : false
                }
                success={
                  password.oldpassword?.length > 0 &&
                  password.oldpassword == password.newpassword
                    ? true
                    : false
                }
                icon={
                  viewPassword
                    ? {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <VisibilityIcon
                              onClick={handlePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            />
                          </Icon>
                        ),
                      }
                    : {
                        direction: "right",
                        component: (
                          <Icon color="action" fontSize="small">
                            <VisibilityOffIcon
                              onClick={handlePasswordVisibility}
                              style={{ cursor: "pointer" }}
                            />
                          </Icon>
                        ),
                      }
                }
              />
              {password.oldpassword?.length > 0 &&
              password.oldpassword !== password.newpassword ? (
                <FormControl error>
                  <FormHelperText>
                  Enter New password
                  </FormHelperText>
                </FormControl>
              ) : null}
            </div>
            <p className="text-danger">{error}</p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "10px",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                style={{
                  backgroundColor: "#3F51B5d4",
                  color: "white",
                  "&:hover": { backgroundColor: "#3F51B5d4" },
                }}
                className={`py-3 px-3 text-l font-bold rounded-md shadow ${
                  loading ? "cursor-not-allowed" : ""
                }`}
                onClick={() => {
                  forgotpassword();
                }}
                // disabled={loading || !formik.isValid}
              >
                {loading ? (
                  <span
                    className="indicator-progress"
                    style={{ display: "block" }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                ) : (
                  "Submit"
                )}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </section>
  );
}
